export default __webpack_public_path__ + "da445a310de801d893c6f2cfcd5b63b1.png";